var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { getGeometryStyle } from '../../helpers/styles';
var StyledGridRow = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  background: ", ";\n  display: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n"], ["\n  ", "\n  background: ", ";\n  display: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n"])), function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridRow.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridRow.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridRow.justifyContent;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridRow.alignItems;
});
var GridRow = function (props) {
    var identifier = props.identifier, type = props.type, restProps = __rest(props, ["identifier", "type"]);
    return React.createElement(StyledGridRow, __assign({ id: identifier }, restProps));
};
export default GridRow;
var templateObject_1;
//# sourceMappingURL=index.js.map